import { Pair as FewV2Pair } from '@ring-protocol/few-v2-sdk'
import { UniverseChainId } from 'uniswap/src/features/chains/types'
import { CurrencyInfo } from 'uniswap/src/features/dataApi/types'
import { areAddressesEqual } from 'uniswap/src/utils/addresses'
import { buildCurrencyId } from 'uniswap/src/utils/currencyId'

type CurrencyAssetIdentity = {
  address: string
  chainId: number
}

/**
 * A locked FewV2 quote already has both tokens from the verified onchain pair.
 * Prefer those tokens over API metadata, which may temporarily inherit an
 * origin token's decimals while the FewToken metadata request is loading.
 */
export function getRequiredPoolCurrencyInfo({
  currencyAsset,
  currencyInfo,
  requiredPoolPair,
}: {
  currencyAsset?: CurrencyAssetIdentity | null
  currencyInfo?: Maybe<CurrencyInfo>
  requiredPoolPair?: FewV2Pair
}): Maybe<CurrencyInfo> {
  if (!currencyAsset || !requiredPoolPair) {
    return currencyInfo
  }

  const requiredPoolCurrency = [requiredPoolPair.token0, requiredPoolPair.token1].find(
    (token) => token.chainId === currencyAsset.chainId && areAddressesEqual(token.address, currencyAsset.address),
  )
  if (!requiredPoolCurrency) {
    return currencyInfo
  }

  return {
    ...currencyInfo,
    currency: requiredPoolCurrency,
    currencyId:
      currencyInfo?.currencyId ??
      buildCurrencyId(requiredPoolCurrency.chainId as UniverseChainId, requiredPoolCurrency.address),
    logoUrl: currencyInfo?.logoUrl ?? null,
  }
}
